export default __webpack_public_path__ + "static/media/projectbased@2x.64398779.png";